import { COLOR_GREEN, COLOR_RED } from "style/theme";
import {
  ShowAllIcon,
  EtfFocusedIcon,
  DayTradingIcon,
  ThematicIcon,
  SmallAccountIcon,
  ETFIcon,
  IndustryIcon,
  IconETFTab,
  // IconETFTabV2,
  BacktestIcon2,
  RocketIcon,
  FaqsIcon,
  BulbIcon,
  // BugIcon,
  MessageIcon,
  MenuSettingsIcon,
  // MenuInviteIcon,
  MenuLogoutIcon,
  SupportIcon,
} from "assets/icons";
import {
  AllocationEditIcon,
  AllocationStarIcon,
  CarIcon,
  EqualIcon,
  FaceIdSquareIcon,
  InstagramIcon,
  InternetIcon,
  LinkInIcon,
  MailIcon,
  MedicalSquareIcon,
  PiggyBank,
  StarsIcon,
  TiktokIcon,
  TrophyIcon,
  TwitterIcon,
  UserIcon,
  Users2Icon,
  coinbaseIcon,
  // robinhoodIcon,
  KrakenIcon,
  IbkrIcon,
  SurmountIcon,
} from "assets/icons/index";

// env variables
export const BASE_URL = import.meta.env.REACT_APP_API_BASE_URL;
export const REACT_APP_VER = import.meta.env.REACT_APP_VERSION;
export const AES_KEY = import.meta.env.REACT_APP_AES_KEY;
export const AWS_RUM_URL = import.meta.env.REACT_APP_AWS_RUM_URL;
export const AWS_GUEST_ROLE_ARN = import.meta.env.REACT_APP_AWS_GUEST_ROLE_ARN;
export const AWS_APP_IDENTITY_POOL = import.meta.env.REACT_APP_IDENTITY_POOL;
export const STRIPE_PUBLISH_KEY = import.meta.env.REACT_APP_STRIPE_PUBLISH_KEY;
export const GA_MEASURMENT_ID = import.meta.env.REACT_APP_GA_MEASURMENT_ID;
export const ENV = import.meta.env.REACT_APP_ENV;
export const GOOGLE_AUTH_ID = import.meta.env.REACT_APP_GOOGLE_AUTH_ID;
export const STRIPE_SUCCESS_URL = import.meta.env.REACT_APP_STRIPE_SUCCESS_URL;
export const STRIPE_CANCEL_URL = import.meta.env.REACT_APP_STRIPE_CANCEL_URL;
export const CAL_LINK = import.meta.env.REACT_APP_CAL_LINK;
export const ORGANIZATION_ID = import.meta.env.REACT_APP_ORGANIZATION_ID;

// Storage keys
export const TRACKING_ID_KEY = "T:ID";
export const USER_ID_KEY = "U:ID";
export const AUTH_TOKEN_KEY = "A:TOKEN";
export const AUTH_RTOKEN_KEY = "A:RTOKEN";
export const ASIDE_STATE_KEY = "ASD:STATE";
export const STORAGE_PERSIST_KEY = "A:PERSIST";
export const IS_DEFAULT_GITHUB_KEY = "IDE:ISDEFAULT";
export const THEME_KEY = "A:THEME";
export const BANNER_KEY = "A:BANNER";
export const LAST_VISIT_KEY = "LV:TIMESTAMP";
export const SNAPTRADE_TIMESTAMP_KEY = "ST:TIMESTAMP";
export const SIGNUP_EMAIL_KEY = "A:SIGNUP_EMAIL";
export const CURRENT_PATH_KEY = "A:CURRENT_PATH";
export const USER_PLAN_KEY = "U:CURRENT_PLAN";
export const USER_TYPE_KEY = "U:TYPE";
export const PURCHASE_PLAN_MODAL_KEY = "A:PURCHASE_PLAN_MODAL";

export const BILLING_INTERVAL = {
  YEARLY: "yearly",
  MONTHLY: "monthly",
};

// What clicking a plan card does, relative to the user's current plan.
export const PLAN_ACTION = {
  // already on this plan then no action
  CURRENT: "current",
  // a downgrade to this plan is already scheduled then no action
  SCHEDULED: "scheduled",
  // cancel to Free (scheduled)
  DOWNGRADE_FREE: "downgrade-free",
  // move to a lower paid tier (scheduled)
  DOWNGRADE_TIER: "downgrade-tier",
  // same tier, yearly -> monthly (pay less, scheduled)
  SWITCH_DOWN: "switch-down",
  // same tier, monthly -> yearly (pay more, immediate)
  SWITCH_UP: "switch-up",
  // higher tier on an active paid sub (immediate proration)
  UPGRADE: "upgrade",
  // free / expired -> paid (Stripe checkout)
  CHECKOUT: "checkout",
};
export const MONETIZATION_KEY = "A:MONETIZATION_KEY";
export const WELCOME_MODAL_KEY = "A:WELCOME_MODAL";
export const SUGGESTED_STRATEGY_MODAL_KEY =
  "A:WELCOME_SUGGESTED_STRATEGY_MODAL";
export const IS_RECOMMENDED_STRATEGY_VIEWED_KEY =
  "A:IS_RECOMMENDED_STRATEGY_VIEWED";

// URLs
export const LANDING_PAGE_URL = "https://surmount.ai/";
export const DOCS_LINK = "https://docs.surmount.ai/";
export const PLANS_LINK = "https://surmount.ai/pricing";

// Others
export const PAGE_SIZE = 16;
export const FALLBACK_LANG = "en";
export const RADIAN = Math.PI / 180;
export const appliedPriceptions = [{ key: "closePrice", title: "Close Price" }];
export const movingAverageTypeptions = [
  { key: "simpleAveraging", title: "Simple averaging" },
];
export const STRATEGY_UNSUB_REASONS = [
  { label: "It's too expensive", value: "too_expensive" },
  { label: "Some features are missing", value: "missing_features" },
  { label: "I'm switching to a different service", value: "switched_service" },
  { label: "I don't use the service enough", value: "unused" },
  {
    label: "Customer service was less than expected",
    value: "customer_service",
  },
  { label: "Ease of use was less than expected", value: "too_complex" },
  { label: "Quality was less than expected", value: "low_quality" },
  { label: "Other", value: "other" },
];

export const STRATEGY_UNSUB_REASONS_V2 = [
  { label: "Technical Issues", value: "technical_issues" },
  { label: "Too expensive", value: "too_expensive" },
  { label: "Switching to another product", value: "switched_service" },
  { label: "The product is too complex", value: "too_complex" },
  { label: "Not meeting my expectations", value: "low_quality" },
  { label: "Other", value: "other" },
];

// Validation Regexes
export const PASSWORD_REGEX = /^(?=.*\d)(?=.*[A-Z])[A-Za-z\d@$!%*#?&-._^]{8,}$/;
export const PASSWORD_MSG =
  "Must contain at least 8 characters, with at least one number and one uppercase character";
("Password must be at least 8 characters long, contain at least one number and one uppercase letter.");

// Individual password criteria regex patterns
export const PASSWORD_LENGTH_REGEX = /.{8,}/;
export const PASSWORD_UPPERCASE_REGEX = /[A-Z]/;
export const PASSWORD_NUMBER_REGEX = /\d/;
export const PASSWORD_SPECIAL_REGEX = /[!@#$%^&*(),.?":{}|<>]/;

export const PUBLISH_STATUS = {
  "-1": { title: "In Review", color: "#0A7EFF" },
  1: { title: "Hosted", color: "#0A7EFF" },
};

export const DEPLOY_STATUS = {
  0: {
    title: "Inactive",
    color: "${({ theme }) => theme.global.color.bodyColor}",
  },
  1: {
    title: "In Review",
    color: "#0A7EFF",
  },
  2: { title: "Deployed", color: COLOR_GREEN },
};

export const HOST_STEPS = [
  {
    key: "submit",
    title: "Submit Strategy",
    isActive: true,
  },
  {
    key: "auto-review",
    title: "Automated Review",
    isActive: true,
  },
  {
    key: "manual-review",
    title: "Manual Review",
    isActive: false,
  },
  {
    key: "hosted",
    title: "Hosted to the Marketplace",
    isActive: false,
  },
];

export const PUBLISH_STATUS_VALUES = {
  IN_REVIEW: -1,
  PUBLISHED: 1,
  NOT_PUBLISHED: 0,
};

export const TIME_FRAME_OPTIONS = [
  { label: "1M", days: 30, duration: { months: 1 } },
  { label: "3M", days: 90, duration: { months: 3 } },
  { label: "6M", days: 180, duration: { months: 6 } },
  { label: "12M", days: 365, duration: { years: 1 } },
  { label: "3Y", days: 1095, duration: { years: 3 } },
  { label: "5Y", days: 1825, duration: { years: 5 } },
];

export const weightTypeOptions = [
  { key: "equal", title: "Equal" },
  { key: "specified", title: "Specified" },
  { key: "marketCap", title: "Market Cap" },
];

export const CHART_TIME_FRAME = [
  {
    id: "1d",
    title: "1D",
  },
  {
    id: "1w",
    title: "1W",
  },
  {
    id: "1m",
    title: "1M",
  },
  {
    id: "3m",
    title: "3M",
  },
  {
    id: "1y",
    title: "1Y",
  },
  {
    id: "5y",
    title: "5Y",
  },
  {
    id: "all",
    title: "All",
  },
];

export const getPortfolioMenu = ({
  isStale,
  manageStrategy,
  isSurmountAccount,
  isConfirmed,
  isBankConnected,
  hasAccountValue,
}) => {
  const isConfirmedConnected =
    isSurmountAccount && isConfirmed && isBankConnected;

  const menu = [
    { key: "edit_name", title: "Edit name" },
    { key: "manage", title: "Manage strategies" },
  ];

  if (isStale || !manageStrategy) {
    return [{ key: "disconnect", title: "Disconnect" }];
  }

  if (isConfirmedConnected && hasAccountValue) {
    return [
      ...menu,
      { key: "change_bank", title: "Change bank" },
      { key: "deposit", title: "Deposit/Withdraw" },
    ];
  }

  if (isConfirmedConnected && !hasAccountValue) {
    return [
      { key: "add_funds", title: "Add funds" },
      { key: "change_bank", title: "Change bank" },
    ];
  }

  return [...menu, { key: "disconnect", title: "Disconnect" }];
};

export const STATUS_CODES = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
};

export const HELP_CENTER_MENU = [
  {
    name: "Get Started",
    key: "getStarted",
  },
  {
    name: "FAQs",
    key: "faqs",
  },
  {
    name: "Report a bug",
    key: "reportBug",
  },
  {
    name: "Contact us",
    key: "contactUs",
  },
  {
    name: "Request a feature",
    key: "requestFeature",
  },
  // {
  //   name: "User Guide",
  //   key: "userGuide",
  // },
];

export const HELP_CENTER_MENU_V2 = [
  {
    name: "Get started",
    description: "Start onboarding flow",
    key: "getStarted",
    icon: <RocketIcon />,
  },
  {
    name: "FAQs",
    description: "Surmount features questions and answers",
    key: "faqs",
    icon: <FaqsIcon />,
  },
  // {
  //   name: "Report a bug",
  //   description: "Found a bug? Let us know",
  //   key: "reportBug",
  //   icon: <BugIcon />,
  // },
  {
    name: "Request a feature",
    description: "What would you like to see next?",
    key: "requestFeature",
    icon: <BulbIcon />,
  },
  {
    name: "Contact us",
    description: "Can't find what you're looking for?",
    key: "contactUs",
    icon: <MessageIcon />,
  },
  // {
  //   name: "User Guide",
  //   key: "userGuide",
  // },
];

export const ALL_FEATURES = [
  {
    value: "nocode builder",
    label: "No code builder",
  },
  {
    value: "code builder",
    label: "Code builder",
  },
  {
    value: "ai builder",
    label: "AI builder",
  },
  {
    value: "marketplace",
    label: "Marketplace",
  },
  {
    value: "live trading",
    label: "Live trading",
  },
  {
    value: "broker connection",
    label: "Broker connection",
  },
  {
    value: "billing",
    label: "Billing",
  },
  {
    value: "other",
    label: "Other",
  },
];

export const USER_GUIDE_MENU = [
  {
    key: "link-portfolio",
    name: "Link a Porfolio",
  },
  {
    key: "manage-portfolio",
    name: "Manage a Porfolio",
  },
  {
    key: "create-strategy",
    name: "Create a Strategy",
  },
  {
    key: "purchase-strategy",
    name: "Purchase a Strategy",
  },
  {
    key: "host-strategy",
    name: "Host a Strategy",
  },
  {
    key: "subscription-plans",
    name: "Subscription Plans",
  },
];

export const helpcenterRequestTypes = {
  requestFeature: "REQUEST_FEATURE",
  contactUs: "CONTACT_US",
};

export const AWS_RUM_KEYS = {
  APPLICATION_ID: "240ef1cd-ce6b-4ef4-8b40-ba553ba77227",
  APPLICATION_VERSION: "1.0.0",
  APPLICATION_REGION: "ap-southeast-2",
};

export const THEME_TYPES = {
  DARK: "dark",
  LIGHT: "light",
};

export const MARKETPLACE_CATEGORY_OPTIONS = (theme) => ({
  key: "category",
  name: "Categories",
  description: "Select your preferred investment strategy",
  options: [
    {
      key: "equity",
      name: "Equity Focused",
      Icon: () => (
        <EtfFocusedIcon
          fill={theme.aside.font.color}
          className="equity-focused"
        />
      ),
      iconClass: "custom-g-path",
      description:
        "Strategies that only trade on equities, with both active & passive options",
    },
    {
      key: "pdt",
      name: "Day Trading",
      Icon: () => <DayTradingIcon fill={theme.aside.font.color} />,
      description:
        "Strategies that trade intraday, looking for an advantage in short time periods",
    },
    {
      key: "thematic",
      name: "Thematic",
      Icon: () => <ThematicIcon fill={theme.aside.font.color} />,
      description:
        "Strategies that invest long-term in a group of companies based on theme or sector",
    },
    {
      key: "small_accounts",
      name: "Small Accounts",
      Icon: () => <SmallAccountIcon fill={theme.aside.font.color} />,
      description:
        "Strategies that are able to trade on smaller accounts (no minimum investment)",
    },
  ],
});

export const MARKETPLACE_INTERVAL_OPTIONS = {
  key: "interval",
  name: "Interval",
  description: "",
  options: [
    {
      key: "max",
      name: "Max",
      description: "Performance of the strategy since inception",
    },
    {
      key: "3m",
      name: "3 Months",
      description: "Strategy Performance over the last 3 months",
    },
    {
      key: "ytd",
      name: "YTD",
      description:
        "Performance of the Strategy from the 1st of this year till today (Year to Date)",
    },
    {
      key: "1y",
      name: "1 Year",
      description: "Strategy Performance over the past year",
    },
    {
      key: "3y",
      name: "3 Years",
      description: "Strategy Performance over the last 3 years",
    },
    {
      key: "5y",
      name: "5 Years",
      description: "Performance of the Strategy over the last 5 years",
    },
  ],
};

export const MARKETPLACE_SORT_OPTIONS = {
  key: "sort",
  name: "Sort By",
  description: "",
  options: [
    {
      name: "Popular",
      description: "The most popular strategies on Surmount",
      key: "popularity",
      order: "desc",
    },
    {
      name: "Highest Annual Return",
      description: "The best performing strategies",
      key: "annualized_return",
      order: "desc",
    },
    {
      name: "Highest Total Return",
      description: "The strategies with the best returns since inception",
      key: "total_return",
      order: "desc",
    },
    {
      name: "Lowest Risk",
      description: "The strategies with the lowest volatility",
      key: "risk_score",
      order: "asc",
    },
    {
      name: "Lowest Max Drawdown",
      description:
        "The strategies with the lowest maximum drawdown since inception",
      key: "mdd",
      order: "asc",
    },
    {
      name: "Most Active",
      description: "The strategies with the most trades per day",
      key: "trades_per_day",
      order: "desc",
    },
    {
      name: "Least Active",
      description: "The strategies with the least trades per day",
      key: "trades_per_day",
      order: "asc",
    },
  ],
};

export const MARKETPLACE_TAB_OPTIONS = (theme) => [
  {
    key: "popularity",
    name: "Show all",
    Icon: () => <ShowAllIcon fill={theme.aside.font.color} />,
  },
  {
    key: "equity",
    name: "Equity Focused",
    Icon: () => <EtfFocusedIcon fill={theme.aside.font.color} />,
    iconClass: "custom-g-path",
  },
  // { key: "crypto", name: "Crypto Focused", icon: cryptoFocusedIcon },
  {
    key: "pdt",
    name: "Day Trading",
    Icon: () => <DayTradingIcon fill={theme.aside.font.color} />,
  },
  {
    key: "thematic",
    name: "Thematic",
    Icon: () => <ThematicIcon fill={theme.aside.font.color} />,
  },
  {
    key: "small_accounts",
    name: "Small Accounts",
    Icon: () => <SmallAccountIcon fill={theme.aside.font.color} />,
  },
  // {
  //   key: "dca",
  //   name: "DCA Strategies",
  //   Icon: () => <DcaIcon fill={theme.aside.font.color} />,
  // },
];

export const SNAPTRADE_ALLOWED_ORIGINS = [
  "https://app.snaptrade.com",
  "https://app.staging.snaptrade.com",
  "https://app.local.snaptrade.com",
  "https://connect.snaptrade.com",
  "http://localhost:4001",
  "https://dev-fe.surmount.ai/",
  "https://staging-fe.surmount.ai/",
  "https://app.surmount.ai/",
];

export const HEAT_MAP_COLOR_SHADES = [
  "#ebedf0",
  "#FF3737",
  "#FF8D8D",
  "#86FBA6",
  "#23E759",
];

export const NCB_INDICATOR_VALIDATION = [1, 500];

export const EARLY_USER_MESSAGE =
  "Thank you for being an early user! You're getting all the benefits of Surmount Premium for free for a limited time!";

export const ETF_TIME_FRAME = [
  {
    label: "Day",
    value: "days",
  },
  {
    label: "Month",
    value: "months",
  },
];

export const COMPANY_DETAILS_TAB_OPTIONS = (theme) => [
  {
    key: "details",
    name: "ETF Builder",
    Icon: () => <IconETFTab fill={theme.aside.font.color} />,
  },
  {
    key: "backtest",
    name: "Backtest",
    Icon: () => <BacktestIcon2 fill={theme.aside.font.color} />,
  },
];

export const COMPANY_DETAILS_TAB_OPTIONS_V2 = [
  {
    key: "details",
    label: "Strategy Builder",
  },
  {
    key: "backtest",
    label: "Backtest",
  },
];

export const ETF_FILTER_SECTOR = [
  "Consumer Cyclical",
  "Energy",
  "Technology",
  "Industrials",
  "Financial Services",
  "Basic Materials",
  "Communication Services",
  "Consumer Defensive",
  "Healthcare",
  "Real Estate",
  "Utilities",
  "Industrial Goods",
  "Financial",
  "Services",
  "Conglomerates",
];

export const ETF_FILTER_INDUSTRY = [
  "Advertising Agencies",
  "Aerospace & Defense",
  "Agricultural Inputs",
  "Airlines",
  "Airports & Air Services",
  "Aluminum",
  // "Apparel Manufacturing",
  // "Apparel Retail",
  "Asset Management",
  // "Auto Manufacturers",
  // "Auto Parts",
  "Auto & Truck Dealerships",
  // "Banks—Diversified",
  // "Banks—Regional",
  // "Beverages—Brewers",
  // "Beverages—Non-Alcoholic",
  // "Beverages—Wineries & Distilleries",
  "Biotechnology",
  "Broadcasting",
  // "Building Materials",
  // "Building Products & Equipment",
  "Business Equipment & Supplies",
  "Business Services",
  "Capital Markets",
  // "CATV Systems",
  "Chemicals",
  // "Closed-End Fund - Equity",
  // "Coking Coal",
  "Communication Equipment",
  // "Communication Services",
  "Computer Hardware",
  "Confectioners",
  "Conglomerates",
  "Consulting Services",
  "Consumer Electronics",
  "Copper",
  "Financial - Credit Services",
  "Department Stores",
  "Diagnostics & Research",
  "Discount Stores",
  // "Drug Manufacturers—General",
  // "Drug Manufacturers—Specialty & Generic",
  "Education & Training Services",
  "Electrical Equipment & Parts",
  // "Electronic Components",
  "Electronic Gaming & Multimedia",
  // "Electronics & Computer Distribution",
  "Engineering & Construction",
  "Entertainment",
  "Farm & Heavy Construction Machinery",
  "Farm Products",
  // "Financial Conglomerates",
  // "Financial Data & Stock Exchanges",
  "Food Distribution",
  "Footwear & Accessories",
  // "Furnishings, Fixtures & Appliances",
  "Gambling",
  "Gold",
  "Grocery Stores",
  "Healthcare Plans",
  // "Health Information Services",
  // "Home Improvement Retail",
  "Household & Personal Products",
  // "Independent Oil & Gas",
  // "Industrial Distribution",
  // "Industrial Metals & Minerals",
  "Information Technology Services",
  "Insurance",
  // "Insurance Brokers",
  // "Insurance—Diversified",
  // "Insurance—Life",
  // "Insurance—Property & Casualty",
  // "Insurance—Reinsurance",
  // "Insurance Specialty",
  // "Insurance—Specialty",
  "Integrated Freight & Logistics",
  "Internet Content & Information",
  // "Internet Retail",
  "Leisure",
  "Lodging",
  "Lumber & Wood Production",
  "Luxury Goods",
  // "Major Airlines",
  "Marine Shipping",
  // "Medical Care Facilities",
  // "Medical Devices",
  // "Medical Distribution",
  // "Medical Instruments & Supplies",
  "Metal Fabrication",
  // "Mortgage Finance",
  "Oil & Gas Drilling",
  "Oil & Gas E&P",
  "Oil & Gas Equipment & Services",
  "Oil & Gas Integrated",
  "Oil & Gas Midstream",
  "Oil & Gas Refining & Marketing",
  // "Other Industrial Metals & Mining",
  // "Other Precious Metals & Mining",
  "Packaged Foods",
  "Packaging & Containers",
  // "Paper & Paper Products",
  // "Personal Services",
  // "Pharmaceutical Retailers",
  "Pollution & Treatment Controls",
  "Publishing",
  "Railroads",
  // "Real Estate—Development",
  // "Real Estate—Diversified",
  // "Real Estate Services",
  "Recreational Vehicles",
  // "REIT—Diversified",
  // "REIT—Healthcare Facilities",
  // "REIT—Hotel & Motel",
  // "REIT—Industrial",
  // "REIT—Mortgage",
  // "REIT—Office",
  // "REIT—Residential",
  // "REIT—Retail",
  // "REIT—Specialty",
  "Rental & Leasing Services",
  "Residential Construction",
  "Resorts & Casinos",
  "Restaurants",
  // "Scientific & Technical Instruments",
  "Security & Protection Services",
  // "Semiconductor Equipment & Materials",
  "Semiconductors",
  "Shell Companies",
  // "Silver",
  // "Software—Application",
  // "Software—Infrastructure",
  "Solar",
  "Specialty Business Services",
  // "Specialty Chemicals",
  // "Specialty Industrial Machinery",
  "Specialty Retail",
  "Staffing & Employment Services",
  "Steel",
  // "Telecom Services",
  // "Textile Manufacturing",
  // "Thermal Coal",
  "Tobacco",
  "Tools & Accessories",
  "Travel Services",
  "Trucking",
  "Uranium",
  // "Utilities Diversified",
  // "Utilities—Diversified",
  // "Utilities—Independent Power Producers",
  // "Utilities Regulated",
  // "Utilities—Regulated Electric",
  // "Utilities—Regulated Gas",
  // "Utilities—Regulated Water",
  // "Utilities—Renewable",
  "Waste Management",
];

export const TIME_INDICATOR = {
  "1D": "today",
  "1W": "past week",
  "1M": "past month",
  "3M": "past quarter",
  "6M": "past six months",
  "1Y": "past year",
  YTD: "past year",
  "3Y": "past three years",
  "5Y": "past five years",
  MAX: "all time",
};

export const STOCK_TAB_OPTIONS = [
  {
    key: "ai-insights",
    name: "AI insights",
  },
  {
    key: "surmount-strategies",
    name: <span className="d-flex">Surmount strategies</span>,
  },
  {
    key: "insider-trades",
    name: "Insider trades",
  },
  {
    key: "congressional-trades",
    name: "Congressional trades",
  },
];

export const STOCK_ASSET_CATEGORY_OPTIONS_V2 = (theme) => ({
  key: "category",
  name: "All Categories",
  description: "Select categories",
  options: [
    // {
    //   key: "sectors",
    //   name: "Sector",
    //   Icon: () => <SectorIcon fill={theme.aside.font.color} />,
    //   description:
    //     "A sector groups similar companies based on their main business activity. (e.g., Technology, Healthcare, Financials)",
    //   options: ETF_FILTER_SECTOR,
    // },
    {
      key: "etf",
      name: "ETF",
      Icon: () => <ETFIcon stroke={theme.aside.font.color} />,
      description:
        "Exchange Traded Fund is a basket of securities that trades like a stock. Offers diversification and ease of investing.",
    },
    {
      key: "industries",
      name: "Industry",
      Icon: () => <IndustryIcon stroke={theme.aside.font.color} />,
      description:
        "An industry is a subdivision of a sector that focuses on a particular product or service. (e.g., Technology - Semiconductors, Software; Healthcare - Pharmaceuticals, Biotechnology)",
      options: ETF_FILTER_INDUSTRY,
    },
  ],
});

export const STOCK_ASSET_CATEGORY_OPTIONS = (theme) => ({
  key: "category",
  name: "All Categories",
  description: "Select categories",
  options: [
    // {
    //   key: "sectors",
    //   name: "Sector",
    //   Icon: () => <SectorIcon fill={theme.aside.font.color} />,
    //   description:
    //     "A sector groups similar companies based on their main business activity. (e.g., Technology, Healthcare, Financials)",
    //   options: ETF_FILTER_SECTOR,
    // },
    {
      key: "industries",
      name: "Industry",
      Icon: () => <IndustryIcon stroke={theme.aside.font.color} />,
      description:
        "An industry is a subdivision of a sector that focuses on a particular product or service. (e.g., Technology - Semiconductors, Software; Healthcare - Pharmaceuticals, Biotechnology)",
      options: ETF_FILTER_INDUSTRY,
    },
    {
      key: "etf",
      name: "ETF",
      Icon: () => <ETFIcon stroke={theme.aside.font.color} />,
      description:
        "Exchange Traded Fund is a basket of securities that trades like a stock. Offers diversification and ease of investing.",
    },
  ],
});

export const NO_DATA_CHART =
  "https://charts-image-bucket.s3.us-east-2.amazonaws.com/allcharts/nodata_chart.png";

export const ROW_NUMBERS = [
  { value: 20, label: 20 },
  { value: 50, label: 50 },
  { value: 100, label: 100 },
];

export const EXPLORE_CHART_FILTERS = [
  { id: "", title: "Max" },
  { id: "3M", title: "3M" },
  { id: "YTD", title: "YTD" },
  { id: "1Y", title: "1Y" },
  { id: "3Y", title: "3Y" },
  { id: "5Y", title: "5Y" },
];

export const EXPLORE_CHART_YEAR_FILTERS = [
  { id: "", title: "All", displayName: "All" },
  { id: "1D", title: "1D", displayName: "1 Day" },
  { id: "7D", title: "7D", displayName: "7 Days" },
  { id: "1M", title: "1M", displayName: "1 Month" },
  { id: "1Y", title: "1Y", displayName: "1 Year" },
];

export const FEAR_GREED_COLORS = {
  80: COLOR_RED,
  60: "#ea8b01",
  40: "#f3d42f",
  20: "#92d700",
  0: "#14c784",
};

export const CHART_COLORS = [
  "#2BC155",
  "#FF3F3F",
  "#253BBD",
  "#336AC2",
  "#4D8FE4",
  "#4DB5E4",
  "#78CEEE",
  "#57DEEA",
  "#7AECE0",
  "#58EACA",
  "#4DE4A6",
  "#59D58C",
  "#51E4A7",
  "#59D58C",
  "#63AF7B",
  "#63ACAF",
  "#637EAF",
  "#6366AF",
  "#8963AF",
];

export const COLOR_PALETTE = [
  "#DAE8FF",
  "#90BFFF",
  "#2258F1",
  "#6938EF",
  "#BDB4FE",
  "#EBE9FE",
  "#22d3ee", // cyan (anchor)
  "#E0E7FF", // indigo-100
  "#C7D2FE", // indigo-200
  "#A5B4FC", // indigo-300
  "#818CF8", // indigo-400
  "#6366F1", // indigo-500
  "#4F46E5", // indigo-600
  "#4338CA", // indigo-700
  "#3730A3", // indigo-800
  "#312E81", // indigo-900
  "#F5F3FF", // violet-50
  "#DDD6FE", // violet-200
  "#C4B5FD", // violet-300
  "#A78BFA", // violet-400
  "#8B5CF6", // violet-500
  "#7C3AED", // violet-600
  "#6D28D9", // violet-700
];

export const PROFILE_MENU_UPPER_V2 = [
  {
    id: "settings",
    name: "Settings",
    icon: <MenuSettingsIcon />,
  },
  {
    id: "support",
    name: "Support",
    icon: <SupportIcon />,
  },
];

export const PROFILE_MENU_LOWER_V2 = [
  {
    id: "signout",
    name: "Sign out",
    icon: <MenuLogoutIcon />,
  },
];

export const IBKR_DOCS = `https://snaptrade.notion.site/End-user-guide-for-connecting-Interactive-Brokers-aa560dac7cdc4cf1b37e5901369a58f8`;

export const STRATEGY_TYPE = [
  {
    title: "All",
    key: "all",
  },
  {
    title: "ETF",
    key: "ETF",
  },
  {
    title: "No code",
    key: "No code",
  },
  {
    title: "Full code",
    key: "Full code",
  },
  {
    title: "AI Code",
    key: "AI Code",
  },
];

export const STRATEGY_STATUS = [
  {
    title: "All",
    key: "All",
  },
  {
    title: "Active",
    key: "active",
  },
  {
    title: "Inactive",
    key: "inactive",
  },
];

export const USER_WALKTHROUGH_FLAGS = {
  HAS_BROKER_CONNECTED: "HAS_BROKER_CONNECTED",
  HAS_STRATEGIES_EXPLORED: "HAS_STRATEGIES_EXPLORED",
  HAS_DEPOSITED: "HAS_DEPOSITED",
  CONNECTED_TO_BANK: "CONNECTED_TO_BANK",
  HAS_INVESTED: "HAS_INVESTED",
  HAS_STRATEGY_CREATED: "HAS_STRATEGY_CREATED",
};

export const USER_FLAGS = {
  SWITCH_TO_NEW_HEALTH_CHECK: "SWITCH_TO_NEW_HEALTH_CHECK",
  INTERNAL_ONBOARDING_COMPLETED: "INTERNAL_ONBOARDING_COMPLETED",
  ...USER_WALKTHROUGH_FLAGS,
};

export const TOS_URL = "https://surmount.ai/terms-of-use";
export const PP_URL = "https://surmount.ai/privacy-policy";

export const welcomeQuestions = [
  {
    question: { key: "what_brings_you", value: "What brings you to Surmount?" },
    subQuestion:
      "Select your priorities below and we'll help you achieve them in Surmount",
    choices: [
      "I want to automate my investments",
      "I want to track all of my investments in one place",
      "I want to create my own data-driven strategies",
      "I want to invest using AI-driven investment models",
      "I want to share my strategies with other investors",
    ],
  },
  // {
  //   enable: false,
  //   question: {
  //     key: "where_did_you_hear",
  //     value: "How did you hear about Surmount?",
  //   },
  //   subQuestion:
  //     "Select your priorities below and we'll help you achieve them in Surmount",
  //   choices: [
  //     "Email",
  //     "Social Media",
  //     "Blog",
  //     "Google",
  //     "Friends/family",
  //     "Other",
  //   ],
  // },
];

export const TYPEFORM_ID = "lox7j0qv";

export const SURMOUNT_TEAM = [
  "abdulrahman@surmount.ai",
  "jasmin@surmount.ai",
  "logan@surmount.ai",
  "justin@surmount.ai",
  "yassa@surmount.ai",
  "haris@surmount.ai",
  "akash@surmount.ai",
  "bilal@surmount.ai",
  "eric@surmount.ai",
  "kelly@surmount.ai",
  "graves.justinb@gmail.com",
];
export const SURMOUNT_TEAM_EMAIL = "hello@surmount.ai";

export const LOCK_MODAL_CONFIG = {
  strategyList: {
    title: "UNLOCK ALL FEATURES",
    privateText:
      "Upgrade your account to access all strategy features including live performance metrics, detailed analytics, and investment tools",
  },
  strategyDetails: {
    title: "UNLOCK ALL METRICS",
    privateText: "Upgrade your account to see the live performance and return",
    publicText:
      "Create an account to see all the information for this strategy",
  },
};

export const CREATE_STRATEGY_TYPE = {
  ETF: "etf",
  NOCODE: "nocode",
  NOCODE_TEMPLATE: "nocode_template",
  LOWCODE: "lowcode",
  FULLCODE: "fullcode",
  AIBUILDER: "promptfolio",
};

const ALL_TYPES = [
  CREATE_STRATEGY_TYPE.ETF,
  CREATE_STRATEGY_TYPE.NOCODE,
  CREATE_STRATEGY_TYPE.NOCODE_TEMPLATE,
  CREATE_STRATEGY_TYPE.LOWCODE,
  CREATE_STRATEGY_TYPE.FULLCODE,
  CREATE_STRATEGY_TYPE.AIBUILDER,
];

export const PLAN_STRATEGY_PERMISSIONS = {
  free: [],
  core: [],
  plus: [
    CREATE_STRATEGY_TYPE.ETF,
    CREATE_STRATEGY_TYPE.NOCODE,
    CREATE_STRATEGY_TYPE.NOCODE_TEMPLATE,
  ],
  pro: ALL_TYPES,
  premium: ALL_TYPES,
  partnership: ALL_TYPES,
};

export const SIGNUP_CONTAINER_STEPS = [
  {
    id: 1,
    title: "About You",
  },
  {
    id: 2,
    title: "Build Your Portfolio",
  },
  {
    id: 3,
    title: "Connect Your Accounts",
  },
  {
    id: 4,
    title: "Deposit Funds",
  },
];

export const PORTFOLIO_BUILDING_STEPS = [
  {
    id: 1,
    title: "Select your strategies",
    step: "1",
  },
  {
    id: 2,
    title: "Set your allocation",
    step: "2",
  },
  {
    id: 3,
    title: "Review and confirm",
    step: "3",
  },
];

export const MONTHLY_OPTION = {
  "specific dates": "specific date(s)",
  first: "first of month",
  last: "last of month",
};

export const WEEK_DAYS = [
  { key: "Monday", label: "M" },
  { key: "Tuesday", label: "T" },
  { key: "Wednesday", label: "W" },
  { key: "Thursday", label: "T" },
  { key: "Friday", label: "F" },
];

export const BUILDER_TABS = [
  { key: "simple", label: "Simple builder" },
  { key: "Advanced", label: "Advanced builder" },
];

// Builder type configurations
export const BUILDER_TYPES = {
  ETF: "etf",
  NO_CODE: "noCode",
};

// Default run schedule applied when a strategy has no time restrictions saved
// yet. Defaults to all weekdays during US market hours so a freshly created
// strategy actually runs instead of defaulting to "None".
export const DEFAULT_TRADE_DAYS = [
  { day: "Monday", start_date: "09:30", end_date: "16:00", is_active: true },
  { day: "Tuesday", start_date: "09:30", end_date: "16:00", is_active: true },
  { day: "Wednesday", start_date: "09:30", end_date: "16:00", is_active: true },
  { day: "Thursday", start_date: "09:30", end_date: "16:00", is_active: true },
  { day: "Friday", start_date: "09:30", end_date: "16:00", is_active: true },
  { day: "Saturday", start_date: "09:30", end_date: "16:00", is_active: false },
  { day: "Sunday", start_date: "09:30", end_date: "16:00", is_active: false },
];

// Default tab mapping for builder types
export const BUILDER_TAB_DEFAULTS = {
  [BUILDER_TYPES.ETF]: "simple",
  [BUILDER_TYPES.NO_CODE]: "Advanced",
};

export const CONTROL_OPTIONS = [
  { value: "equal", label: "Equal", icon: <EqualIcon /> },
  { value: "suggest", label: "Suggest", icon: <AllocationStarIcon /> },
  { value: "custom", label: "Custom", icon: <AllocationEditIcon /> },
];

export const INVESTMENT_OPTION = [
  { icon: <MedicalSquareIcon />, text: "Invest in Quantum Computing" },
  {
    icon: <UserIcon />,
    text: "Companies that benefit from Gen-Z consumer habits",
  },
  {
    icon: <Users2Icon />,
    text: "Companies with lots of users, but low ARPU",
  },
  {
    icon: <CarIcon />,
    text: "Invest in self-driving automations",
  },
  {
    icon: <TrophyIcon />,
    text: "Invest in companies that run Superbowl ads",
  },
  {
    icon: <StarsIcon />,
    text: "Companies that Andreessen Horowitz invested in",
  },
  {
    icon: <FaceIdSquareIcon />,
    text: "Top Warren Buffett Stocks",
  },
  {
    icon: <PiggyBank />,
    text: "B2B companies with notably high revenue per employee",
  },
];

export const SOCIAL_LINKS_DATA = [
  { href: "#", icon: <InternetIcon /> },
  { href: "#", icon: <MailIcon /> },
  { href: "#", icon: <TwitterIcon /> },
  { href: "#", icon: <LinkInIcon /> },
  { href: "#", icon: <InstagramIcon /> },
  { href: "#", icon: <TiktokIcon /> },
];

export const BLOCKED_BROKERS = ["ROBINHOOD", "TRADIER"];
export const BM_SERIES_KEY = "Benchmark Value (SPY)";

export const HIDDEN_KEY_STATS = [
  "Total Trades",
  "Losing Trades",
  "Winning Trades",
  "Days Active",
  "Recommended Allocation",
];
export const TIMEFRAMES = [
  "1D",
  "1W",
  "1M",
  "3M",
  "6M",
  "YTD",
  "1Y",
  "3Y",
  "5Y",
];

export const PUBLIC_TIMEFRAMES = [
  { id: "1w", title: "1W" },
  { id: "1m", title: "1M" },
  { id: "1y", title: "1Y" },
  { id: "all", title: "All" },
];
export const TIMEFRAME_LABELS = {
  "1d": "today",
  "1w": "past week",
  "1m": "past month",
  "3m": "past 3 months",
  "6m": "past 6 months",
  ytd: "year to date",
  "1y": "past year",
  "3y": "past 3 years",
  "5y": "past 5 years",
  all: "all time",
  max: "all time",
};

export const BROKER_PLATFORMS = [
  {
    id: "surmount",
    name: "Surmount",
    icon: SurmountIcon,
    hasNewBadge: true,
    useBrokerIcon: true,
  },
  {
    id: "coinbase",
    name: "Coinbase",
    icon: coinbaseIcon,
    useBrokerIcon: false,
  },
  // {
  //   id: "robinhood",
  //   name: "Robinhood",
  //   icon: robinhoodIcon,
  //   useBrokerIcon: false,
  // },
  {
    id: "kraken",
    name: "Kraken",
    icon: KrakenIcon,
    useBrokerIcon: false,
  },
  {
    id: "ibkr",
    name: "IBKR",
    icon: IbkrIcon,
    useBrokerIcon: false,
  },
  {
    id: "and-more",
    name: "And more",
    isAndMore: true,
    count: "+10",
  },
];
export const TRANSACTION_TYPE = {
  DEPOSIT: "deposit",
  WITHDRAWAL: "withdrawal",
  REBALANCE: "rebalance",
  TRADE: "trade",
};

export const CASH_TRANSFER_TYPE = {
  DEPOSIT: "deposit",
  WITHDRAW: "withdraw",
};

export const TRADE_SIDE = {
  BUY: "buy",
  SELL: "sell",
};

export const DISCLOSURE_TYPE = {
  INSIDER: "insider",
  PUBLIC_FIGURE: "public_figure",
  PUBLIC_RESEARCH: "public_research",
};

export const getInsiderDisclosure = () =>
  "This strategy is based on publicly available information, and is not based on insider knowledge. Methodology can be validated by referencing public information.";

export const getPublicFigureDisclosure = (name) =>
  `This strategy tracks publicly disclosed trades filed by ${name} under the STOCK Act. It is not affiliated with, sponsored by, or endorsed by ${name} or their office. Disclosures can lag up to 45 days and may be incomplete or later amended. Past trades aren't a guarantee of future results.`;

export const getPublicResearchDisclosure = (name) =>
  `This strategy's logic is inspired by publicly published tactical asset allocation research. ${name} and his affiliated entities have not reviewed, endorsed, sponsored, or participated in its creation, and no partnership or business relationship exists between ${name} and Surmount AI, Inc., or their affiliates.`;

export const ORDER_BROKERAGE_DISCLOSURES_ID = "order-brokerage-disclosures";

export const ORDER_BROKERAGE_DISCLOSURES = [
  "Submitting this order authorizes Surmount to buy, sell, and rebalance positions for this strategy in your linked brokerage account.",
  "Surmount submits orders to your brokerage; your brokerage executes them. Orders are placed at the next available market price, which may differ from prices shown here. Orders placed outside market hours are submitted when trading next opens.",
  "Execution practices differ by brokerage — including whether fractional shares are supported, order minimums, and how quickly funds settle. As a result, a portion of your investment amount may remain un-invested in your account. Un-invested cash is included in the balance used to calculate your Surmount advisory fee. Any interest paid on cash is determined by your brokerage, not by Surmount.",
  "Because of these differences, your holdings and returns will differ from the strategy's target allocations and its published performance.",
];

export const getStrategyDisclosure = (disclosureType, disclosureSubject) => {
  switch (disclosureType) {
    case DISCLOSURE_TYPE.INSIDER:
      return getInsiderDisclosure();
    case DISCLOSURE_TYPE.PUBLIC_FIGURE:
      return getPublicFigureDisclosure(disclosureSubject);
    case DISCLOSURE_TYPE.PUBLIC_RESEARCH:
      return getPublicResearchDisclosure(disclosureSubject);
    default:
      return null;
  }
};
